import { request } from "./request";

/**
 * Fetches data from the API
 * @param data
 * @param apiUrl
 * @param authToken Authorization token header to be added to make the call
 * @returns Promise
 */

export async function fetch<DATA_TYPE, RETURN_TYPE>(data: DATA_TYPE, authToken: string, apiUrl: string): Promise<RETURN_TYPE> {
  return await request<RETURN_TYPE>(
    {
      url: apiUrl,
      method: "POST",
      data: data,
    },
    authToken,
  );
}
